import { TraceTypes } from '@/helpers/graph-helper'
import _ from 'lodash'

export const ENROLLMENT_PRECISION = 2

export const TableTypes = {
  PRE_SCREENING: 'pre-screening',
  SUMMARY: 'summary',
  ENROLLMENT: 'enrollment',
  DISTRIBUTION: 'distribution',
  PRACTICE_SELECTION: 'practice selection'
}

export const SubTableTypes = {
  enrollment: {
    MONTHLY: 'monthly',
    TOTAL: 'total',
    PROJECTED: 'projected'
  },
  notEligible: {
    CRITERIA_NOT_MET: 'criteriaNotMet',
    REASONS: 'reasons'
  }
}

export const DefaultSelectedTraces = {
  summary: [
    TraceTypes.FOLLOWING,
    TraceTypes.MATCHED,
    TraceTypes.NOT_CONSENTED,
    TraceTypes.NOT_ELIGIBLE,
    TraceTypes.ENROLLED
  ],
  enrollment: [TraceTypes.ENROLLED],
  distribution: _.values(TraceTypes),
  'pre-screening': [TraceTypes.AWAITING_REVIEW, TraceTypes.IN_REVIEW]
}

export const HeaderTooltips = {
  'pre-screening': {
    averageDaysPreScreening: [
      'Average time between patient identification and placement into Following, Matched, Enrolled, Not Consented, or Not Eligible'
    ],
    averageDaysAwaitingReview: [
      'Average time between patient identification and care team taking action'
    ],
    averageDaysInReview: [
      'Average time between the care team taking action and patient placement into Following, Matched, Enrolled, Not Consented, or Not Eligible'
    ],
    patientCount: [
      'Potentially eligible patients identified by Paradigm Platform who meet a core set of required criteria',
      'This is the total count of patients identified.',
      '(Awaiting Review, In Review and those Pre-Screened: Following, Matched, Enrolled, Not Consented, and Not Eligible)'
    ],
    patientAwaitingReviewCount: [
      'Note about Automation: “Awaiting Review” updates automatically as data or logic evolve. Fluctuations reflect improved accuracy — showing who truly meets your trial’s current criteria.',
      'If you have questions about how this works, please reach out to Paradigm staff.'
    ],
    patientInReviewCount: [
      'Count of patients In Review',
      '% of patients In Review compared to the Total identified'
    ],
    patientCompletedCount: [
      'Total Following, Matched, Enrolled, Not Consented and Not Eligible patients',
      '% of patients Pre-Screened compared to the Total Identified'
    ]
  },
  summary: {
    currentDuration: [
      'Time between Paradigm Platform enrollment started at one or more practice to current date'
    ],
    monthlyEnrollmentDifference: [
      'The percentage difference between your actual monthly enrollment rate and your target monthly enrollment rate'
    ],
    averageDaysPreScreening: [
      'Average time between patient identification and placement into Following, Matched, Enrolled, Not Consented, or Not Eligible'
    ],
    patientCompletedCount: [
      'Patients in a status of Matched, Enrolled, Not Consented, Not Eligible'
    ],
    patientFollowingCount: [
      "Patients screened who meet most of the criteria but we're following for progression or test results"
    ],
    patientMatchedCount: [
      'Patients who match the eligibility criteria for the trial and require action to enroll'
    ],
    patientEnrolledCount: [
      'Count of patients Enrolled within Paradigm Platform',
      '% of patients Enrolled compared to the total patients Enrolled, Not Consented, or Not Eligible'
    ],
    patientNotConsentedCount: [
      'Count of patients who were not Consented to the trial in Paradigm Platform',
      '% of patients who were not Consented compared to the total patients Enrolled, Not Consented, or Not Eligible'
    ],
    patientNotEligibleCount: [
      'Count of patients Not Eligible for the trial after Pre-Screening within Paradigm Platform',
      '% of patients Not Eligible compared to the total patients Enrolled, Not Consented, or Not Consented'
    ]
  },
  enrollment: {
    targetMonthlyEnrollment: [
      "Number of patients expected monthly based on the trial's target enrollment"
    ],
    averageMonthlyEnrollment: [
      'Number of patients enrolled so far divided by number of months elapsed from trial start'
    ],
    monthlyEnrollmentDifference: [
      'The percentage difference between your actual monthly enrollment rate and your target monthly enrollment rate'
    ],
    currentDuration: ['Time between enrollment start date and current date'],
    plannedEnrollmentToDate: [
      "Number of expected patients to date based on the trial's target enrollment"
    ],
    patientEnrolledCount: ['Count of patients marked as Enrolled within Paradigm Platform'],
    targetDuration: ["Time between enrollment start and trial's desired primary completion date"],
    targetEnrollment: ["Trial's target enrollment"],
    projectedTotalEnrollment: [
      'Projection of how many patients will be enrolled based on the Actual Monthly Enrollment Rate'
    ]
  },
  distribution: {
    patientCount: [
      'Potentially eligible patients identified by Paradigm Platform who meet a core set of required criteria',
      'This is the total count of patients identified.',
      '(Awaiting Review, In Review and those Pre-Screened: Following, Matched, Enrolled, Not Consented, and Not Eligible)'
    ],
    patientAwaitingReviewCount: [
      'Note about Automation: “Awaiting Review” updates automatically as data or logic evolve. Fluctuations reflect improved accuracy — showing who truly meets your trial’s current criteria.',
      'If you have questions about how this works, please reach out to Paradigm staff.'
    ],
    patientInReviewCount: ["The care team is making updates to the patient's eligibility criteria"],
    patientNotEligibleCount: [
      'Count of patients Not Eligible for the trial after Pre-Screening within Paradigm Platform'
    ],
    patientFollowingCount: [
      "Patients screened who meet most of the criteria but we're following for progression or test results"
    ],
    patientMatchedCount: [
      'Patients who match the eligibility criteria for the trial and require action to enroll'
    ],
    patientNotConsentedCount: [
      'Count of patients who were not Consented to the trial in Paradigm Platform'
    ],
    patientEnrolledCount: ['Count of patients Enrolled within Paradigm Platform'],
    targetEnrollment: ["Trial's target enrollment"]
  },
  'practice selection': {
    patientCount: [
      'Potentially eligible patients identified by Paradigm Platform who meet a core set of required criteria'
    ],
    patientInPreScreeningCount: [
      'Count of patients that require Pre-Screening to determine a status'
    ],
    patientFollowingCount: [
      "Patients screened who meet most of the criteria but we're following for progression or test results"
    ],
    patientMatchedCount: [
      'Patients who match the eligibility criteria for the trial and require action to enroll'
    ],
    patientNotEligibleCount: [
      'Count of patients Not Eligible for the trial after Pre-Screening within Paradigm Platform'
    ]
  }
}

export function getHeaderTooltip(table, columnValue) {
  return HeaderTooltips[table] && HeaderTooltips[table][columnValue]
    ? HeaderTooltips[table][columnValue]
    : []
}
